import React, { useState } from 'react';

export const Login = () => {
    const [usuario, setUsuario] = useState('');
    const [password, setPassword] = useState('');

    const handleLogin = async (e) => {
        e.preventDefault();
        try {
            // Ajustá localhost o la IP según donde estés probando
            const res = await fetch('https://api.pascolo.com.ar/api/admin/login', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ usuario, password })
            });
            const data = await res.json();

            if (res.ok) {
                sessionStorage.setItem('adminToken', data.token); // Guardamos la pulsera VIP
                window.location.href = '/admin/dashboard'; // Redirigimos
            } else {
                alert(data.error);
            }
        } catch (error) {
            alert("Error al conectar con el servidor");
        }
    };

    return (
        // Este contenedor empuja el footer hacia abajo
        <div style={{ minHeight: '60vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            
            <form onSubmit={handleLogin} style={{ display: 'flex', flexDirection: 'column', gap: '15px', width: '100%', maxWidth: '350px', padding: '20px' }}>
                <h2 style={{ textAlign: 'center', marginBottom: '10px' }}>Acceso Dashboard</h2>
                
                <input 
                    type="text" 
                    placeholder="Usuario" 
                    onChange={e => setUsuario(e.target.value)} 
                    style={{ padding: '10px', borderRadius: '5px', border: '1px solid #ccc' }}
                />
                <input 
                    type="password" 
                    placeholder="Contraseña" 
                    onChange={e => setPassword(e.target.value)} 
                    style={{ padding: '10px', borderRadius: '5px', border: '1px solid #ccc' }}
                />
                <button 
                    type="submit" 
                    style={{ padding: '12px', backgroundColor: '#000', color: '#fff', border: 'none', borderRadius: '5px', cursor: 'pointer', fontWeight: 'bold' }}
                >
                    Ingresar al Panel
                </button>
            </form>

        </div>
    );
};